// COFFEETRACK_PRICING_SINGLE_SOURCE_V320
//
// Единственный источник денежных значений меню.
//
// Сейчас это DEMO-прайс.
// После получения настоящего меню владельца
// меняем значения здесь, а не в UI/API.
//
// catalog.ts использует этот объект,
// а сервер пересчитывает заказ по catalog.ts,
// поэтому клиент и сервер получают одинаковые цены.
//

export const pricingStatus =
  "demo" as const;

export const pricing = {
  products: {
    cappuccino: 190,
    latte: 210,
    americano: 160,
    raf: 240,

    cocoa: 190,
    tea: 170,

    bumble: 260,
    "iced-latte": 240,
    lemonade: 220,
    smoothie: 260,
    "juice-bowl": 290,

    hotdog: 250,
    frenchdog: 260,
    corndog: 220,
    fries: 180,
    nuggets: 230,
    "cheese-sticks": 250,
    shrimp: 320,
  },

  sizes: {
    coffee: {
      "300": 0,
      "400": 40,
    },

    largeDrink: {
      "400": 0,
      "500": 50,
    },

    tea: {
      "400": 0,
      "500": 30,
    },

    fries: {
      standard: 0,
      large: 70,
    },

    nuggets: {
      "6": 0,
      "9": 90,
    },
  },

  addons: {
    coffee: {
      syrup: 30,
      "alt-milk": 60,
      "extra-shot": 50,
    },

    americano: {
      syrup: 30,
      "extra-shot": 50,
    },

    cocoa: {
      syrup: 30,
      "alt-milk": 60,
    },

    hotdog: {
      "cheese-sauce": 30,
      jalapeno: 30,
      beef: 40,
    },
  },
} as const;

export type ProductPriceId =
  keyof typeof pricing.products;
